// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-backstage[data-v-4d508184]:after{background-color:#2e4787}.navbar-backstage[data-v-4d508184]:before{border-color:transparent transparent #2e4787 transparent}", ""]);
// Exports
module.exports = exports;
